import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import { Url } from '@wix/da-url';
import BaseTierUpsell from './BaseTierUpsell';
export const ExploreMoreTierUpsell = ({ className, authorName })=>{
    const { t } = useTranslation();
    return authorName ? /*#__PURE__*/ React.createElement(BaseTierUpsell, {
        className: className,
        imageSrc: Url.staticCDNLink('eclipse/global/svg/tier-upsell-explore-more.svg?1'),
        imageWidth: "113px",
        title: t('deviation.tier.upsell.title.exploreMore', {
            authorName
        }),
        subtitle: t('deviation.tier.upsell.subtitle.exploreMore'),
        buttonText: t('deviation.tier.upsell.button.exploreMore'),
        href: Url.userLink(authorName),
        biData: BiData({
            evid: 2,
            click_info: 'tier.upsell.explore_more',
            sectionname: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
            typeid: BiContextProvidedValue,
            itemid: BiContextProvidedValue
        })
    }) : null;
};
ExploreMoreTierUpsell.displayName = 'ExploreMoreTierUpsell';
export default ExploreMoreTierUpsell;
